export default __webpack_public_path__ + "static/media/help.34826cc3.svg";